export default "__VITE_ASSET__EwB8Cm2s__"